var BASWebServices;
(function (BASWebServices) {
    var TermsOfUsageService = (function () {
        function TermsOfUsageService($http) {
            this.$http = $http;
            this.getTOUFromServer();
        }
        TermsOfUsageService.Factory = function ($http) {
            return new TermsOfUsageService($http);
        };
        TermsOfUsageService.prototype.getTOUContentAcademic = function () {
            return this.touAcademic;
        };
        TermsOfUsageService.prototype.getTOUContentCommercial = function () {
            return this.touCommercial;
        };
        TermsOfUsageService.prototype.getTOUFromServer = function () {
            this.touAcademic = this.$http.get(BASWebServices.ConfigService.GET_TERMS_OF_USAGE_ACADEMIC_URL());
            this.touCommercial = this.$http.get(BASWebServices.ConfigService.GET_TERMS_OF_USAGE_COMMERCIAL_URL());
        };
        return TermsOfUsageService;
    }());
    BASWebServices.TermsOfUsageService = TermsOfUsageService;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=TermsOfUsageService.js.map